import { Injectable } from '@angular/core';
import { StktsServicePkg } from './stktsPkg.service';
import { Stkts } from '../entity/Stkts-angular';
import { idNameItem } from 'jk-service';

@Injectable({
  providedIn: 'root',
})
export class StktsService extends StktsServicePkg {
  newItem: Stkts = this.getDefaultItem(); // new Stkts();
  buysaleTitle: string = '';

  get buysale(): string {
    return this.newItem.TS008.toString();
  }
  set buysale(value: string) {
    if (!value) return;
    this.newItem.TS008 = parseInt(value);
    if (this.newItem.TS008 === 0) {
      this.buysaleTitle = '確認買進';
    } else {
      this.buysaleTitle = '確認賣出';
    }
  }
  onBuySaleValueChange($event: string) {
    //this.buysale = $event;
    this.newItem.TS008 = parseInt($event);
    if (this.newItem.TS008 === 0) {
      this.buysaleTitle = '確認買進';
    } else {
      this.buysaleTitle = '確認賣出';
    }
  }
  get period(): string {
    return this.newItem.TS006.toString();
  }
  set period(value: string) {
    this.newItem.TS006 = parseInt(value);
  }
  // 0:ROD 1:IOC 2:FOK
  ts011List: idNameItem[] = [
    { id: '0', name: 'ROD' },
    { id: '1', name: 'IOC' },
    { id: '2', name: 'FOK' },
  ];
  get ts011(): string {
    return this.newItem.TS011.toString();
  }
  set ts011(value: string) {
    this.newItem.TS011 = parseInt(value);
  }
  specialTradeTypeList: idNameItem[] = [
    { id: '1', name: '市價' },
    { id: '2', name: '限價' },
  ];
  get specialTradeType(): string {
    return this.newItem.TS012.toString();
  }
  set specialTradeType(value: string) {
    this.newItem.TS012 = parseInt(value);
    if (this.newItem.TS012 === 1) {
      this.newItem.TS009 = '0'; // 市價單之委託價格Price請給0
    }
  }
  ts014YN: string = 'N'; // 虛構
  get qty(): number {
    return this.newItem.TS010;
  }
  set qty(value: number) {
    this.newItem.TS010 = value;
  }
  // TS011 委託條件 N     4   [DEF:0] SHORT	sTradeType;	0:ROD  1:IOC  2:FOK
  get tradeType(): string {
    return this.newItem.TS011.toString();
  }
  set tradeType(value: string) {
    this.newItem.TS011 = parseInt(value);
  }

  constructor() {
    super();
    this.defaultManagerField(this.newItem, true);
    this.newItem.TS001 = this.nowDate();
    this.newItem.KEY0 = '1';
    this.newItem.TS011 = 0;
    this.newItem.TS012 = 2; //[證券逐筆交易] 1:市價 2:限價 (市價單之委託價格Price請給0; 限價單之委託價格Price 不可為0)
    //this.idNameOpt.sqlSelect= `SELECT ME001 as id,ME002 as name,ME001+'-'+ME002 as idName,ME002+'-'+ME001 as nameId,ME003 as ps1 FROM STKME `;
    //this.idNameOpt.sqlWhere= `  `
    //this.idNameOpt.sqlOrder= 'ORDER BY ME001';
    //this.loadIdNameList(this.idNameOpt);
  }
  get stockno(): string {
    return this.newItem.TS005;
  }
  set stockno(value: string) {
    this.newItem.TS005 = value;
  }
  async doBeforeSend(uId: string): Promise<boolean> {
    this.newItem.TS018 = uId;
    this.newItem.TS001 = this.nowDate();
    this.newItem.TS027 = this.nowTime8();
    if (this.newItem.TS010 === 0) {
      alert('委託數量不可為0');
      return false;
    }
    let ret = await this.orm.autoNo(
      'data',
      this.tableName,
      this.keyFields.join(','),
      this.newItem.TS001 + ',' + this.newItem.TS002,
      this.newItem.TS001
    );
    if (ret.result) {
      this.newItem.TS003 = ret.data;
      let bool = this.checkRequiredFields(this.newItem, ret);
      if (!bool) return false;
    } else {
      alert('取序號錯誤:' + ret.message);
      return false;
    }
    return true;
  }
}
